import type { SVGProps } from "react";
// generated from CircleCheckFilled.svg — do not edit manually
// prettier-ignore
export default function CircleCheckFilled(props: SVGProps<SVGSVGElement>) {
  return (<svg viewBox="0 0 24 24" fill="none"
  xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M12 2C15.0162 2 17.7183 3.3374 19.5518 5.44922L11.0635 13.9375L7.53223 10.3809L6.46777 11.4375L11.0605 16.0625L20.457 6.66504C21.4332 8.20922 22 10.0381 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2Z" fill="currentColor"/>
</svg>);
}
